import axios from 'axios';

export default function httpRequest(requestConfig = {}) {
  console.log('httpRequest START requestConfig');
  return axios(requestConfig).then(
    (response) => {
      return response;
    },
    (responseWithError) => {
      const data =
        responseWithError &&
        responseWithError.response &&
        responseWithError.response.data;

      throw data;
    }
  );
}
